import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardModels} from 'src/app/models/dashboard-models';
import {DashboardService} from 'src/app/services/dashboard.service';
import {MainDataService} from 'src/app/services/main-data.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {SpeedDialItemEventArgs, SpeedDialItemModel} from '@syncfusion/ej2-angular-buttons';
import {MainDataModels} from 'src/app/models/maindata-models';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {HelperService} from '../../../services/helper.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-dashboard-mobile',
    templateUrl: './dashboard-mobile.component.html',
    styleUrls: ['./dashboard-mobile.component.scss'],
})
export class DashboardMobileComponent implements OnInit {
    resultsLength = 0;
    public cntAppointmentdsToday?: number = undefined;
    public cntTasks?: number = undefined;
    public cntNotes?: number = undefined;
    public menuItems: SpeedDialItemModel[] = [];
    /* Zuletzt verwendte Objekte */
    isLoadingObjectsResults = true;
    dataSourceObjekte!: MatTableDataSource<DashboardModels.DashboardObjekt>;
    displayedObjektColumns: string[] = ['objectNo', 'typeDesc', 'desc', 'objekt'];
    selectedObjectID = '';
    /* Zuletzt verwendte Adressen */
    isLoadingAddressesResults = true;
    dataSourceAdressen!: MatTableDataSource<DashboardModels.DashboardAdresse>;
    displayedAdresseColumns: string[] = [
        'adressNo',
        'name',
        'vorname',
        'strasse',
    ];
    selectedAdressID = '';
    /* Datenstatus */
    hasLastViewedObjects = 0; // 0: nein | 1: ja
    hasLastViewedAddresses = 0; // 0: nein | 1: ja
    snackBarIsOpen = 0; // 0: nein | 1: ja
    counter = 0;
    /* Badge-Icons: Anzahl Heutige Termine / Heutige Aufgaben / Heutige Notizen  */
    private dashboardIcons?: DashboardModels.DashboardBadgeIcons = undefined;
    private objektUrl!: string;
    private adresseUrl!: string;
    private dbNotizen?: MainDataModels.Notiz[];
    private destroyRef = inject(DestroyRef);

    constructor(
        private userAuthService: UserAuthenticationService,
        private helperService: HelperService,
        private router: Router,
        private route: ActivatedRoute,
        private svcDashboard: DashboardService,
        private snackBar: MatSnackBar,
        private svcMainData: MainDataService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
        this.matIconRegistry
            .addSvgIcon(
                'ss-logo',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    'assets/images/swiss-soft-logo_zentriert_black.svg'
                )
            );

        // Wurde der Browser aktualisiert?
        if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
            this.helperService.setPageRefreshURL('/dashboard-mobile');
            // Zu Homelayout navigieren
            this.router.navigate(['']);
        }

        this.dataSourceObjekte =
            new MatTableDataSource<DashboardModels.DashboardObjekt>();
        this.objektUrl =
            this.route.snapshot.queryParams.returnUrl || '/objekte-mobile';

        this.dataSourceAdressen =
            new MatTableDataSource<DashboardModels.DashboardAdresse>();
        this.adresseUrl =
            this.route.snapshot.queryParams.returnUrl || '/adressen-mobile';
    }

    ngOnInit(): void {
        this.countCntNotes();
        this.reloadDashbordBadgeIcons();
        this.reloadDashboardObjekte();
        this.reloadDashboardAdressen();
    }

    openTasks() {
        this.router.navigateByUrl('dashboard-mobile/meineaufgabenmobile');
    }

    openNotes() {
        this.router.navigateByUrl('dashboard-mobile/meinenotizenmobile');
    }

    openAppointments() {
        this.router.navigateByUrl('dashboard-mobile/meineterminemobile');
    }

    showDashboard() {
        return this.router.url == '/dashboard-mobile';
    }

    countCntNotes() {

        // Pendenzen Live vom Webservice holen
        this.svcMainData.getUserNotes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.dbNotizen = res;
                this.dbNotizen.forEach(res => {
                    if (res.wasRead === 0) {
                        this.counter += 1;
                    }
                });
            },
            error: () => {
                // Webservice nicht verfügbar --> aus IndexedDB laden
                // Todo
            },
        });
    }

    public speedMenuClicked(args: SpeedDialItemEventArgs): void {
        switch (args.item.id) {
            case (args.item.id = 'settings'):
                this.router.navigate(['/appeinstellungen-mobile']);
                break;
            case (args.item.id = 'logout'):
                this.userAuthService.logoutUser('/login');
                break;
            default:
                return;
        }
    }

    public speedMenuCreated(): void {
        this.menuItems = [];
        this.menuItems.push({text: 'Einstellungen', id: 'settings'});
        this.menuItems.push({text: 'Abmelden', id: 'logout'});
    }

    highlight(row: any) {
        this.selectedObjectID = row.objectID;
        if (row.objectID) {
            this.router.navigate([this.objektUrl, this.selectedObjectID]);
        }
    }

    highlightAdr(row: any) {
        this.selectedAdressID = row.adressID;
        if (row.adressID) {
            this.router.navigate([this.adresseUrl, this.selectedAdressID]);
        }
    }

    logout(): void {
        this.userAuthService.logoutUser('/login');
    }

    private reloadDashbordBadgeIcons() {
        this.svcDashboard.getDashboardBadgeIcons().subscribe({
            next: (res) => {
                this.dashboardIcons = res;
                this.cntAppointmentdsToday = this.dashboardIcons.cntAppointmentdsToday;
                this.cntTasks = this.dashboardIcons.cntTasks;
                this.cntNotes = this.counter;
            },
        });
    }

    private reloadDashboardObjekte() {
        // Die durch den Benutzer zuletzt geöffneten Objekte ermitteln
        this.svcDashboard.getDashboardObjekte().subscribe({
            next: (res) => {
                this.resultsLength = res.length;

                if (this.resultsLength > 0) {
                    this.hasLastViewedObjects = 1;
                } else {
                    this.hasLastViewedObjects = 0;
                }

                // Die nächste Code-Zeile muss so bleiben, wegen der Performance.
                this.dataSourceObjekte! = new MatTableDataSource<DashboardModels.DashboardObjekt>(res);
                this.isLoadingObjectsResults = false;
            },
        });
    }

    private reloadDashboardAdressen(): void {
        // Die durch den Benutzer zuletzt geöffneten Adressen ermitteln
        this.svcDashboard.getDashboardAdressen().subscribe({
            next: (res) => {
                this.resultsLength = res.length;

                if (this.resultsLength > 0) {
                    this.hasLastViewedAddresses = 1;
                } else {
                    this.hasLastViewedAddresses = 0;
                }

                // Die nächste Code-Zeile muss so bleiben, wegen der Performance.
                this.dataSourceAdressen! = new MatTableDataSource<DashboardModels.DashboardAdresse>(res);
                this.isLoadingAddressesResults = false;
            },
        });
    }
}
